// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rules-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.rules-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.rules-header h1 {
  margin: 0;
  color: #fff;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.add-btn.violation {
  background: #f04747;
}

.add-btn.violation:hover {
  background: #d84040;
}

.tab-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tab-buttons button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.tab-buttons button.active,
.tab-buttons button:hover {
  background: #5865f2;
  color: white;
}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.rule-category {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
}

.category-title {
  color: #5865f2;
  margin: 0 0 15px 0;
  font-size: 18px;
  border-bottom: 1px solid #40444b;
  padding-bottom: 10px;
}

.rules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
}

.rule-card {
  background: #36393f;
  border-radius: 6px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.rule-content {
  flex: 1 1;
}

.rule-id {
  color: #72767d;
  font-size: 11px;
  font-weight: bold;
}

.rule-text {
  color: #dcddde;
  margin: 8px 0;
  font-size: 14px;
}

.rule-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

.penalty {
  color: #f04747;
  font-weight: bold;
  font-size: 13px;
}

.delete-btn {
  background: transparent;
  color: #f04747;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.delete-btn:hover {
  background: rgba(240, 71, 71, 0.2);
}

.violations-list {
  background: #2f3136;
  border-radius: 8px;
  overflow: hidden;
}

.violations-table {
  width: 100%;
  border-collapse: collapse;
}

.violations-table th,
.violations-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #40444b;
}

.violations-table th {
  background: #36393f;
  color: #b9bbbe;
  font-size: 12px;
  text-transform: uppercase;
}

.violations-table td {
  color: #dcddde;
  font-size: 14px;
}

.violations-table td.penalty {
  color: #f04747;
  font-weight: bold;
}

.no-data {
  text-align: center;
  color: #72767d;
  padding: 40px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Rules.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".rules-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.rules-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.rules-header h1 {\n  margin: 0;\n  color: #fff;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.add-btn.violation {\n  background: #f04747;\n}\n\n.add-btn.violation:hover {\n  background: #d84040;\n}\n\n.tab-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.tab-buttons button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.tab-buttons button.active,\n.tab-buttons button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.rules-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.rule-category {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.category-title {\n  color: #5865f2;\n  margin: 0 0 15px 0;\n  font-size: 18px;\n  border-bottom: 1px solid #40444b;\n  padding-bottom: 10px;\n}\n\n.rules-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 10px;\n}\n\n.rule-card {\n  background: #36393f;\n  border-radius: 6px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.rule-content {\n  flex: 1;\n}\n\n.rule-id {\n  color: #72767d;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.rule-text {\n  color: #dcddde;\n  margin: 8px 0;\n  font-size: 14px;\n}\n\n.rule-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n.penalty {\n  color: #f04747;\n  font-weight: bold;\n  font-size: 13px;\n}\n\n.delete-btn {\n  background: transparent;\n  color: #f04747;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.delete-btn:hover {\n  background: rgba(240, 71, 71, 0.2);\n}\n\n.violations-list {\n  background: #2f3136;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.violations-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.violations-table th,\n.violations-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #40444b;\n}\n\n.violations-table th {\n  background: #36393f;\n  color: #b9bbbe;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.violations-table td {\n  color: #dcddde;\n  font-size: 14px;\n}\n\n.violations-table td.penalty {\n  color: #f04747;\n  font-weight: bold;\n}\n\n.no-data {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
